import { atom } from "jotai";

 const LoadAtom=atom<boolean>(false)

 export default LoadAtom;